import { ReservationType } from "@/lib/gql/__generated__/graphql";

import { FeatureIslandCategoryQuestionForMain } from "@/components/features/_layouts/island/main-with-category/components/category-main-question";

import { RadioGroupField } from "@/components/ui/form/fields/radio-field/radio-group";

import { useReservationBaseReservationType } from "./hooks/use-base-reservation-type";

export const QuestionReservationBaseReservationType = () => {
	const { isEdited, hasError, baseReservationType, onSetBaseReservationType, baseReservationTypeOptions } =
		useReservationBaseReservationType();

	const title = "リクエスト予約設定";
	const guide =
		"リクエスト予約で受け付けることを選択した場合、施設の予約はリクエスト予約のみ受け付けます。<br />※お客様よりリクエストが送られた時点で一時的に在庫を確保いたします。<br />※宿泊日当日までに施設よりお客様への返信がない場合は予約が成立したことになり、 お客様が来訪する可能性がありますのでご注意ください。";

	return (
		<FeatureIslandCategoryQuestionForMain
			required={false}
			title={title}
			isEdited={isEdited}
			hasError={hasError}
			guide={guide}
			inputChildren={
				<div className="flex flex-col gap-y-4">
					<RadioGroupField
						value={baseReservationType?.value ?? ReservationType.Normal}
						options={baseReservationTypeOptions}
						handleValueChange={onSetBaseReservationType}
					/>
					<p className="text-brand">※リクエスト予約にした場合、全ての予約において適用されます。</p>
				</div>
			}
		/>
	);
};

QuestionReservationBaseReservationType.displayName = "QuestionReservationBaseReservationType";
